<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <v-card v-if="isSpinnerVisible">
      <div class="progressWrapper">
        <v-progress-circular
          :size="70"
          :width="7"
          color="green"
          indeterminate
          class="spinner"
        />
      </div>
    </v-card>
    <v-card v-if="!isSpinnerVisible">
      <v-card-title>
        <span class="headline">{{ dialogTitle }}</span>
      </v-card-title>
      <v-card-text>
        <p class="descriptionWrapper">{{ dialogDescription }}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click="_onDismiss">
          {{ cancelButtonText }}
        </v-btn>
        <v-btn color="primary" text @click="_onConfirm">
          {{ confirmButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
export default {
  name: "ConfirmDialog",
  props: {
    dialogTitle: {
      type: String,
      default: "Please confirm",
    },
    dialogDescription: {
      type: String,
      default: "Are you sure you want to perform the action?",
    },
    confirmButtonText: {
      type: String,
      default: "Confirm",
    },
    cancelButtonText: {
      type: String,
      default: "Dismiss",
    },
    isSpinnerVisible: {
      type: Boolean,
      default: false,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  watch: {},
  methods: {
    _onConfirm() {
        this.$emit('on-confirm');
    },
    _onDismiss() {
        this.$emit('on-dismiss');
    },
  },
};
</script>

<style lang="scss" scoped>
.container.container--fluid .v-overlay.v-overlay--active.theme--dark {
  z-index: 210 !important;
}
.descriptionWrapper {
  font-size: 1.4rem;
  margin: 4rem 0 5rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.progressWrapper {
  height: 20rem;
}
</style>
